import { AppBar, FormControlLabel, Switch, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import { toogleTheme } from '../../../redux/reducers/themeSlice';
import PageRoutesData from '../../../routes/data/pageRoutesData';
import DashboardDrawer from './dashBoardDrawer';
import Logo from '../../../Assets/Images/MotiLogo2.png';
import { drawerWidth } from '../../../utils/constant';

export default function DashBoardMenu() {
  const darkMode = useSelector((state) => state.theme.darkMode);
  const dispatch = useDispatch();
  let textColor = 'white';
  return (
    <Gene20Box>
      <Gene20Box
        display={{ xs: 'flex', xl: 'none' }}
        component={NavLink}
        to="/"
        alignItems="center"
        top={0}
        right={0}
        // p={1.625}
        sx={{ cursor: 'pointer' }}
      >
        <AppBar>
          <Toolbar
            sx={{
              bgcolor: 'rgba(0,0,0,0.9)',
              alignItems: 'left',
              display: 'flex',
              padding: 0,
              margin: 0,
              width: drawerWidth,
            }}
          >
            <Gene20Box
              // justifyContent="right"
              align="right"
            >
              <Gene20Box component="img" src={Logo} sx={{ width: { xs: '50vw' } }} height="5vh" />
            </Gene20Box>
          </Toolbar>
        </AppBar>
      </Gene20Box>

      <Toolbar />
      <Gene20Box>
        z
        {PageRoutesData.map((item, index) => (
          <DashboardDrawer item={item} key={index} textColor={textColor} />
        ))}
      </Gene20Box>
      <Gene20Box
        sx={{
          // justifyContent: 'center',
          // justifyItems: 'center',
          // align: 'center',
          // display: 'block',
          padding: '2vh',
          // bottom: '0',
          // background: 'inherit',
          // position: 'sticky',
          // width: drawerWidth,
        }}
      >
        <FormControlLabel
          control={<Switch checked={darkMode} onChange={() => dispatch(toogleTheme())} />}
          label="enable dark mode"
        />
      </Gene20Box>
    </Gene20Box>
  );
}
